// extracted by mini-css-extract-plugin
module.exports = {"page":"management-page_page__2Pk72"};